import {
  FormInput,
  PasswordInput,
  SubmitButton,
  AuthLink,
  WelcomeMessage,
} from "@/components/ui";
import { motion } from "framer-motion";
import logo from "@/assets/img/icons/logo.svg";

interface RegistrationStep2Props {
  onSubmit: () => void;
  onLoginClick: () => void;
  email: string;
  firstPassword: string;
  secondPassword: string;
  firstPasswordVisible: boolean;
  secondPasswordVisible: boolean;
  emailError: string | null;
  firstPasswordError: string | null;
  secondPasswordError: string | null;
  error: string | null;
  setEmail: (email: string) => void;
  setFirstPassword: (firstPassword: string) => void;
  setSecondPassword: (secondPassword: string) => void;
  setFirstPasswordVisible: (firstPasswordVisible: boolean) => void;
  setSecondPasswordVisible: (secondPasswordVisible: boolean) => void;
}

export const RegisterStep2: React.FC<RegistrationStep2Props> = ({
  onSubmit,
  onLoginClick,
  email,
  firstPassword,
  secondPassword,
  firstPasswordVisible,
  secondPasswordVisible,
  emailError,
  firstPasswordError,
  secondPasswordError,
  error,
  setEmail,
  setFirstPassword,
  setSecondPassword,
  setFirstPasswordVisible,
  setSecondPasswordVisible,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="h-full"
    >
      <div className="flex flex-col items-center mb-6">
        <img src={logo} alt="logo" className="w-50 h-50 mb-2 mt-4" />
      </div>
      <WelcomeMessage
        text="Для создания аккаунта укажите электронную почту и пароль"
        textAlign="left"
        className="rounded-lg"
        showOverlay={false}
      />
      <div className="flex flex-col gap-6 w-full">
        <FormInput
          id="email"
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          error={emailError}
        />
        <PasswordInput
          id="password"
          label="Пароль"
          value={firstPassword}
          onChange={setFirstPassword}
          visible={firstPasswordVisible}
          onToggleVisibility={() =>
            setFirstPasswordVisible(!firstPasswordVisible)
          }
          error={firstPasswordError}
        />
        <PasswordInput
          id="passwordConfirm"
          label="Повторите пароль"
          value={secondPassword}
          onChange={setSecondPassword}
          visible={secondPasswordVisible}
          onToggleVisibility={() =>
            setSecondPasswordVisible(!secondPasswordVisible)
          }
          error={secondPasswordError}
        />
        <div className="flex flex-col">
          <div
            className={`text-red-500 text-sm text-center p-2 ${
              error ? "block" : "hidden"
            }`}
          >
            {error}
          </div>
          <SubmitButton text="Создать аккаунт" onClick={onSubmit} />
        </div>
      </div>
      <div className="flex flex-col items-center flex-1 px-4 pb-6 w-full max-w-[430px] mx-auto mt-2">
        <AuthLink
          question="У вас уже есть аккаунт?"
          linkText="Войти"
          onClick={onLoginClick}
        />
      </div>
    </motion.div>
  );
};
export default RegisterStep2;
